/*
 * Cross-sell rows in the buy box.
 *
 * WHAT THIS FILE DOES NOT DO, deliberately.
 *
 * It does not open, re-render or repair the cart drawer, and it does not
 * format money. The DripEz original had to do all three because its theme gave
 * it no way in; here DWCart.add() already performs the add, updates the header
 * count, re-renders the drawer, announces the result, holds the busy lock and
 * surfaces errors, so duplicating any of it would only create a second version
 * to drift out of step. Prices are rendered by Liquid and read from the
 * embedded variant JSON, so market currency and formatting are never re-derived
 * here.
 *
 * It also does not animate the rows or manage their expanded state. Each row is
 * a <details data-dw-acc>, so assets/dw-accordion.js owns the open and close —
 * along with the keyboard handling and the screen-reader state that come with a
 * real disclosure element.
 *
 * OPEN MEANS SELECTED. There is no separate checkbox. A row that is open is in
 * the order, which is why the rows carry no name attribute: several are
 * supposed to be open at once.
 *
 * WHY dw:accordion:intent AND NOT toggle. The native toggle event fires when
 * the open attribute actually changes, and dw-accordion.js deliberately holds
 * open for the length of a closing animation. Listening for toggle alone would
 * leave the total stale for the whole 320ms of a deselect, which reads as a
 * broken button. The intent event fires the moment the shopper acts; toggle is
 * kept as a backstop for anything that changes open without going through a
 * click.
 */
(function () {
  'use strict';

  if (window.__dwCrossSellReady) return;
  window.__dwCrossSellReady = true;

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function blockOf(el) { return el.closest('[data-dw-xsell]'); }
  function cardOf(el) { return el.closest('[data-dw-xsell-card]'); }

  /* ---- per-card state ---------------------------------------------------- */

  function state(card) {
    if (card.__xs) return card.__xs;

    var raw = card.querySelector('[data-dw-xsell-variants]');
    var variants = [];
    if (raw) {
      try { variants = JSON.parse(raw.textContent) || []; }
      catch (e) { variants = []; }
    }

    // Start from the first sellable variant, so a row whose first variant is
    // sold out does not open into an unbuyable state.
    var first = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].a) { first = variants[i]; break; }
    }
    if (!first) first = variants[0] || null;

    card.__xs = {
      variants: variants,
      chosen: first ? (first.o || []).slice() : [],
      qty: 1
    };
    return card.__xs;
  }

  function match(st, chosen) {
    for (var i = 0; i < st.variants.length; i++) {
      var v = st.variants[i], o = v.o || [], ok = true;
      for (var j = 0; j < chosen.length; j++) {
        if (o[j] !== chosen[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  /* Would this value still lead to something sellable, holding the other
     choices fixed? Answering per value is what lets the row strike through a
     size that only exists in a colour the shopper has not picked. */
  function reachable(st, index, value) {
    for (var i = 0; i < st.variants.length; i++) {
      var v = st.variants[i];
      if (!v.a) continue;
      var o = v.o || [];
      if (o[index] !== value) continue;
      var ok = true;
      for (var j = 0; j < st.chosen.length; j++) {
        if (j !== index && st.chosen[j] != null && o[j] !== st.chosen[j]) { ok = false; break; }
      }
      if (ok) return true;
    }
    return false;
  }

  function sync(card) {
    var st = state(card);
    var current = match(st, st.chosen);

    each(card.querySelectorAll('[data-dw-xsell-value]'), function (btn) {
      var idx = parseInt(btn.getAttribute('data-opt'), 10);
      var val = btn.getAttribute('data-val');
      btn.setAttribute('aria-pressed', st.chosen[idx] === val ? 'true' : 'false');
      if (reachable(st, idx, val)) btn.removeAttribute('data-unavailable');
      else btn.setAttribute('data-unavailable', '');
    });

    var price = card.querySelector('[data-dw-xsell-price]');
    if (price && current && current.m) price.textContent = current.m;

    var img = card.querySelector('.dw-xsell__media img');
    if (img && current && current.img) img.src = current.img;

    var qty = card.querySelector('[data-dw-xsell-qty-value]');
    if (qty) qty.textContent = st.qty;

    st.variant = current && current.a ? current : null;
  }

  function choose(card, index, value) {
    var st = state(card);
    var trial = st.chosen.slice();
    trial[index] = value;

    // If that combination is not sellable, move the OTHER options to the
    // nearest one that is, rather than leaving the shopper on a dead variant
    // and disabling the button with no explanation.
    var found = match(st, trial);
    if (!found || !found.a) {
      for (var i = 0; i < st.variants.length; i++) {
        var v = st.variants[i];
        if (v.a && (v.o || [])[index] === value) { trial = (v.o || []).slice(); break; }
      }
    }
    st.chosen = trial;
    sync(card);
  }

  /* ---- buy bar ----------------------------------------------------------- */

  /* open === selected, except while a row is animating shut: dw-accordion.js
     keeps `open` set for that stretch and marks the element __dwClosing. */
  function selected(block) {
    return Array.prototype.filter.call(
      block.querySelectorAll('[data-dw-xsell-card]'),
      function (card) { return card.hasAttribute('open') && !card.__dwClosing; }
    );
  }

  function updateBar(block) {
    if (!block) return;
    var items = [];
    each(selected(block), function (card) {
      var st = state(card);
      if (st.variant) items.push({ id: st.variant.id, quantity: st.qty || 1 });
    });
    block.__xsItems = items;

    var btn = block.querySelector('[data-dw-xsell-buy]');
    if (!btn) return;
    var count = items.reduce(function (n, i) { return n + i.quantity; }, 0);
    var total = block.querySelector('[data-dw-xsell-buy-total]');
    if (total) total.textContent = count ? '(' + count + ')' : '';
    btn.disabled = items.length === 0;
  }

  function buy(block) {
    var items = (block.__xsItems || []).slice();
    if (!items.length) return;

    var btn = block.querySelector('[data-dw-xsell-buy]');
    var label = block.querySelector('[data-dw-xsell-buy-label]');
    var original = label ? label.textContent : '';
    if (btn) { btn.disabled = true; btn.setAttribute('data-dw-loading', ''); }
    if (label) label.textContent = 'ADDING…';

    var done = function () {
      if (label) label.textContent = original;
      if (btn) btn.removeAttribute('data-dw-loading');
      updateBar(block);
    };

    if (!(window.DWCart && window.DWCart.add)) {
      // dw-cart.js is what owns adding on this theme. Without it, fall back to
      // a normal form post rather than silently doing nothing.
      var form = document.createElement('form');
      form.method = 'post';
      form.action = '/cart/add';
      items.forEach(function (i) {
        var id = document.createElement('input');
        id.type = 'hidden'; id.name = 'items[][id]'; id.value = i.id;
        var q = document.createElement('input');
        q.type = 'hidden'; q.name = 'items[][quantity]'; q.value = i.quantity;
        form.appendChild(id); form.appendChild(q);
      });
      document.body.appendChild(form);
      form.submit();
      return;
    }

    window.DWCart.add(items).then(done, done);
  }

  /* ---- events ------------------------------------------------------------ */

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var value = e.target.closest('[data-dw-xsell-value]');
    if (value) {
      e.preventDefault();
      if (value.hasAttribute('data-unavailable')) return;
      var card = cardOf(value);
      choose(card, parseInt(value.getAttribute('data-opt'), 10), value.getAttribute('data-val'));
      updateBar(blockOf(value));
      return;
    }

    var step = e.target.closest('[data-dw-xsell-qty]');
    if (step) {
      e.preventDefault();
      var c = cardOf(step);
      var st = state(c);
      st.qty = Math.max(1, st.qty + parseInt(step.getAttribute('data-dw-xsell-qty'), 10));
      sync(c);
      updateBar(blockOf(step));
      return;
    }

    var go = e.target.closest('[data-dw-xsell-buy]');
    if (go) {
      e.preventDefault();
      buy(blockOf(go));
    }
  });

  function onIntent(e) {
    var card = e.target && e.target.closest && e.target.closest('[data-dw-xsell-card]');
    if (!card) return;
    if (card.hasAttribute('open')) sync(card);
    updateBar(blockOf(card));
  }
  document.addEventListener('dw:accordion:intent', onIntent);
  document.addEventListener('toggle', onIntent, true);   // backstop; toggle does not bubble

  function init() {
    each(document.querySelectorAll('[data-dw-xsell]'), function (block) {
      each(block.querySelectorAll('[data-dw-xsell-card]'), function (card) { sync(card); });
      updateBar(block);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
